import type { BadgeDesignTokens, BadgeTokenSections } from '@openng/optimus-ui-themes/types/badge';

export const sm: BadgeTokenSections.Sm = {
	minWidth: '1.5rem',
	height: '1.5rem',
};

export const colorScheme: BadgeTokenSections.ColorScheme = {
	light: {
		warn: {
			background: '{feedback.warn.accent.color}',
		},
	},
};

export const extend: BadgeTokenSections.Extend = {
	noneRisk: {
		full: {
			background: '{surface.100}',
		},
		half: {
			background: '{surface.200}',
			fill: '{surface.50}',
		},
	},
	verySmallRisk: {
		full: {
			background: '{green.100}',
		},
		half: {
			background: '{green.200}',
			fill: '{green.50}',
		},
	},
	smallRisk: {
		full: {
			background: '{green.500}',
		},
		half: {
			background: '{green.500}',
			fill: '{green.50}',
		},
	},
	mediumRisk: {
		full: {
			background: '{yellow.500}',
		},
		half: {
			background: '{yellow.500}',
			fill: '{yellow.50}',
		},
	},
	highRisk: {
		full: {
			background: '{red.500}',
		},
		half: {
			background: '{red.500}',
			fill: '{red.50}',
		},
	},
};

export default {
	sm,
	colorScheme,
	extend,
} satisfies BadgeDesignTokens;
